(() => {
  const initialise = (root) => {
    if (root.dataset.mftReady === 'true') return;
    root.dataset.mftReady = 'true';

    const form = root.closest('form[action*="/cart/add"]');
    const lengthInput = root.querySelector('[data-mft-length]');
    const widthInput = root.querySelector('[data-mft-width]');
    const cuttingStrip = root.querySelector('[data-mft-cutting-strip]');
    const position = root.querySelector('[data-mft-position]');
    const positionInputs = position.querySelectorAll('input[type="radio"]');
    const paperSizeInput = root.querySelector('[data-mft-paper-size]');
    const fileSummary = root.querySelector('[data-mft-file-summary]');

    if (!form || !lengthInput || !widthInput || !cuttingStrip) return;

    const validateNumber = (input, label) => {
      const value = Number(input.value);
      const minimum = Number(input.min);
      const maximum = Number(input.max);

      input.setCustomValidity('');
      if (!input.value) {
        input.setCustomValidity(`Enter the ${label}.`);
      } else if (!Number.isInteger(value)) {
        input.setCustomValidity(`${label} must be a whole number of millimetres.`);
      } else if (value < minimum || value > maximum) {
        input.setCustomValidity(
          `${label} must be between ${minimum} and ${maximum} mm.`
        );
      }
      return input.checkValidity();
    };

    const updateCuttingStrip = () => {
      const enabled = cuttingStrip.checked;
      position.hidden = !enabled;
      position.disabled = !enabled;
      positionInputs.forEach((input) => {
        input.disabled = !enabled;
        input.required = enabled;
      });
    };

    const updateSummary = () => {
      const length = Number(lengthInput.value);
      const width = Number(widthInput.value);
      const validLength = validateNumber(lengthInput, 'length');
      const validWidth = validateNumber(widthInput, 'width');

      if (!validLength || !validWidth) {
        fileSummary.textContent =
          'Enter valid dimensions to confirm the drawing format.';
        return;
      }

      const paperSize = length <= 2400 ? 'A4' : 'A3';
      paperSizeInput.value = paperSize;
      fileSummary.textContent =
        `${length} × ${width} mm — ${paperSize} PDF at 1:10, plus full-size DXF.`;
    };

    [lengthInput, widthInput].forEach((input) => {
      input.addEventListener('input', updateSummary);
      input.addEventListener('blur', () => {
        validateNumber(input, input === lengthInput ? 'length' : 'width');
      });
    });

    cuttingStrip.addEventListener('change', updateCuttingStrip);

    form.addEventListener(
      'submit',
      (event) => {
        updateCuttingStrip();
        const validLength = validateNumber(lengthInput, 'length');
        const validWidth = validateNumber(widthInput, 'width');
        if (!validLength || !validWidth) {
          event.preventDefault();
          event.stopImmediatePropagation();
          (validLength ? widthInput : lengthInput).reportValidity();
        }
      },
      true
    );

    updateCuttingStrip();
    updateSummary();
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-mft-configurator]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
